// icons
import * as iconBoard from "assets/desktop/icons/game/board";
import * as iconCookFighting from "assets/desktop/icons/game/cock-fighting";
import * as iconFishing from "assets/desktop/icons/game/Fishing";
import * as iconLive from "assets/desktop/icons/game/live";
import * as iconLottery from "assets/desktop/icons/game/lottery";
import * as iconSlots from "assets/desktop/icons/game/slots";
import * as iconSport from "assets/desktop/icons/game/sport";
import * as imageCookFighting from "assets/desktop/images/Game/cock-fighting";
import * as imageFishing from "assets/desktop/images/Game/Fishing";
import * as imageLive from "assets/desktop/images/Game/live";
import * as imageLottery from "assets/desktop/images/Game/lottery";
import * as imageSport from "assets/desktop/images/Game/sport";
import * as iconCookFightingMobile from "assets/mobile/icons/game/cook-fighting";
import * as iconLiveMobile from "assets/mobile/icons/game/live";
import * as iconLotteryMobile from "assets/mobile/icons/game/lottery";
import * as iconSportMobile from "assets/mobile/icons/game/sport";
export interface ProviderItemType {
  icon: string; // icon menu game
  logo_60_40: string; // logo image sub game
  card_logo_lg: string; // logo card image
  logo_lg: string; // logo image
  image: string; // image game
  provider_code: string; // provider code
  provider_name: string;
  type: string; // game type
  bg_color?: string; // background color header sub game
  text_color?: string; // text color header sub game
  active_color?: string; // background color item filter sub game
  text_active_color?: string; // text color item filter sub game
  bg_hover?: string; // background color hover
  button_bg_hover?: string; // background color button hover
  text_button_hover?: string; // text color button hover
  //mobile
  iconMobile?: string;
  imageMobile?: string;
  game_code?: string;
  //
  isLocal?: boolean;
}

export interface GamePageConfigType {
  logo: string;
  background: string;
  bg_color?: string; // background color header sub game
  text_color?: string; // text color header sub game
  active_color?: string; // background color item filter sub game
  text_active_color?: string; // text color item filter sub game
}

export interface ProviderGamesType {
  [x: string]: ProviderItemType[];
}

export const providerGames: ProviderGamesType = {
  // 1. live game
  LC: [
    {
      type: "LC",
      provider_code: "GX",
      provider_name: "GX Trực tuyến",
      icon: iconLiveMobile.gx,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.gx_live,
      iconMobile: iconLiveMobile.gx,
      imageMobile: "/v2/mobile/live/gx.png",
    },
    {
      type: "LC",
      provider_code: "DG",
      provider_name: "DG Trực tuyến",
      icon: iconLive.dg,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.lb_dg,
      iconMobile: iconLiveMobile.dg,
      imageMobile: "/v2/mobile/live/DG.png",
    },
    {
      type: "LC",
      provider_code: "SX",
      provider_name: "SE Trực tuyến",
      icon: iconLive.se,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.se_live,
      iconMobile: iconLiveMobile.se,
      imageMobile: "/v2/mobile/live/SE.png",
    },
    {
      type: "LC",
      provider_code: "EVO",
      provider_name: "EVO Trực tuyến",
      icon: iconLive.evo,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.evo_live,
      iconMobile: iconLiveMobile.evo,
      imageMobile: "/live-mobile/3.png",
    },
    {
      type: "LC",
      provider_code: "WM",
      provider_name: "WM Trực tuyến",
      icon: iconLive.wm,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.wm_live,
      iconMobile: iconLiveMobile.wm,
      imageMobile: "/v2/mobile/live/WM.png",
    },
    {
      type: "LC",
      provider_code: "AG",
      provider_name: "AG Trực tuyến",
      icon: iconLive.ag,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.ag_live,
      iconMobile: iconLiveMobile.ag,
      imageMobile: "/live-mobile/5.png",
    },
    {
      type: "LC",
      provider_code: "SA",
      provider_name: "SA Trực tuyến",
      icon: iconLive.sa,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.sa_live,
      iconMobile: iconLiveMobile.sa,
      imageMobile: "/v2/mobile/live/SA.png",
    },
    {
      type: "LC",
      provider_code: "PT",
      provider_name: "PT Trực tuyến",
      icon: iconLive.pt,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.pt_live,
      iconMobile: iconLiveMobile.pt,
      imageMobile: "/live-mobile/7.png",
    },
    {
      type: "LC",
      provider_code: "BG",
      provider_name: "BG Trực tuyến",
      icon: iconLive.bg,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.bg_live,
      iconMobile: iconLiveMobile.bg,
      imageMobile: "/v2/mobile/live/bg.png",
    },
    {
      type: "LC",
      provider_code: "XG",
      provider_name: "XG Trực tuyến",
      icon: iconLive.xg,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.xg_live,
      iconMobile: iconLiveMobile.xg,
      imageMobile: "/live-mobile/9.png",
    },
    {
      type: "LC",
      provider_code: "TP",
      provider_name: "TP Trực tuyến",
      icon: iconLive.tp,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.tp_live,
      iconMobile: iconLiveMobile.tp,
      imageMobile: "/live-mobile/10.png",
    },
    {
      type: "SL",
      provider_code: "PP",
      provider_name: "PP Trực tuyến",
      icon: iconSlots.pp,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.pp_slots,
      iconMobile: iconSlots.pp_60_40,
      imageMobile: "/v2/mobile/live/pp.png",
    },
    {
      type: "LC",
      provider_code: "AB",
      provider_name: "AB Trực tuyến",
      icon: iconLive.ab,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.ab_live,
      iconMobile: iconLiveMobile.ab,
      imageMobile: "/live-mobile/11.png",
    },
    {
      type: "LC",
      provider_code: "MG1",
      provider_name: "MG Trực tuyến",
      icon: iconLive.mg,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.mg_live,
      iconMobile: iconLiveMobile.mg,
      imageMobile: "/live-mobile/12.png",
    },

    {
      type: "LC",
      provider_code: "PM",
      provider_name: "PM Trực tuyến",
      icon: iconLive.pm,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLive.pm_live,
      iconMobile: iconLiveMobile.pm,
      imageMobile: "/live-mobile/13.png",
    },
  ],
  // 2. slots game
  SL: [
    {
      type: "SL",
      provider_code: "PGS2",
      provider_name: "PG Điện Tử",
      icon: iconSlots.pg,
      logo_60_40: iconSlots.pg_60_40,
      card_logo_lg: iconSlots.pg_60_40,
      logo_lg: iconSlots.pg_logo_lg,
      image: "",
      bg_color: "#000",
      text_color: "#fff",
      active_color: "#ff1c4f",
      text_active_color: "#fff",
      bg_hover: "#ff1c4f",
      button_bg_hover: "#ff1c4f",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "JILI",
      provider_name: "JILI Điện Tử",
      icon: iconSlots.jili,
      logo_60_40: iconSlots.jili_60_40,
      card_logo_lg: iconSlots.jili_logo_lg,
      logo_lg: iconSlots.jili_gaming,
      image: "",
      bg_color:
        "linear-gradient(to bottom, #fff468 0, #f3b720 33%, #eaa000 66%)",
      text_color: "#fff",
      active_color: "#642801",
      text_active_color: "#fff",
      bg_hover: "#f3b720",
      button_bg_hover: "#f3b720",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "TP",
      provider_name: "TP Điện Tử",
      icon: iconSlots.tp,
      logo_60_40: iconSlots.tp_60_40,
      card_logo_lg: iconSlots.tp_card_logo_lg,
      logo_lg: iconSlots.tp_logo_lg,
      image: "",
      bg_color: "#0550bb",
      text_color: "#fff",
      active_color: "#003580",
      text_active_color: "#fff",
      bg_hover:
        "linear-gradient(to bottom, #11dac9 10%, #389dff 55%, #0550bb 100%)",
      button_bg_hover:
        "linear-gradient(to bottom, #11dac9 10%, #389dff 55%, #0550bb 100%)",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "PP",
      provider_name: "PP Điện Tử",
      icon: iconSlots.pp,
      logo_60_40: iconSlots.pp_60_40,
      card_logo_lg: iconSlots.pp_60_40,
      logo_lg: iconSlots.pp_logo_lg,
      image: "",
      bg_color: "#ff800d",
      text_color: "#fff",
      active_color: "#333",
      text_active_color: "#fff",
      bg_hover: "#ff800d",
      button_bg_hover: "#333",
      text_button_hover: "#ff800d",
    },
    {
      type: "SL",
      provider_code: "CQ9",
      provider_name: "CQ9 Điện Tử",
      icon: iconSlots.cq9,
      logo_60_40: iconSlots.cq9_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.cq9_logo_lg,
      image: "",
      bg_color: "#f2941a",
      text_color: "#fff",
      active_color: "#fddb00",
      text_active_color: "#000",
      bg_hover: "#fddb00",
      button_bg_hover: "#f2941a",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "MG",
      provider_name: "MG Điện Tử",
      icon: iconSlots.mg,
      logo_60_40: iconSlots.mg_60_40,
      card_logo_lg: iconSlots.mg_card_logo_lg,
      logo_lg: iconSlots.mg_logo_lg,
      image: "",
      bg_color: "#32b5e9",
      text_color: "#fff",
      active_color: "#21e519",
      text_active_color: "#000",
      bg_hover: "#32b5e9",
      button_bg_hover: "linear-gradient(45deg, #21e519, #32b5e9)",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "JDB",
      provider_name: "JDB Điện Tử",
      icon: iconSlots.jdb,
      logo_60_40: iconSlots.jdb_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.jdb_logo_lg,
      image: "",
      bg_color: "#60bb00",
      text_color: "#fff",
      active_color: "#ffc600",
      text_active_color: "#000",
      bg_hover: "#ffc600",
      button_bg_hover: "#60bb00",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "SPRIBE",
      provider_name: "Spribe Điện Tử",
      icon: iconSlots.spribe,
      logo_60_40: iconSlots.spribe_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.spribe_logo_lg,
      image: "",
      bg_color: "#dbdeee",
      text_color: "#000",
      active_color: "#2e2691",
      text_active_color: "#fff",
      bg_hover: "#2e2691",
      button_bg_hover: "#453ade",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "FC",
      provider_name: "FC Điện Tử",
      icon: iconSlots.fc,
      logo_60_40: iconSlots.fc_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.fc_logo_lg,
      image: "",
      bg_color: "#000",
      text_color: "#fff",
      active_color: "#fa0",
      text_active_color: "#fff",
      bg_hover: "#ffaa00",
      button_bg_hover: "#fa0",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "VA",
      provider_name: "VA Điện Tử",
      icon: iconSlots.va,
      logo_60_40: iconSlots.va_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.va_logo_lg,
      image: "",
      bg_color: "#33b5e9",
      text_color: "#fff",
      active_color: "#0062d5",
      text_active_color: "#fff",
      bg_hover: "#33b5e9",
      button_bg_hover: "#33b5e9",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "BNG",
      provider_name: "BNG Điện Tử",
      icon: iconSlots.bng,
      logo_60_40: iconSlots.bng_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.bng_logo_lg,
      image: "",
      bg_color: "#3ce897",
      text_color: "#000",
      active_color: "#ffd000",
      text_active_color: "#fff",
      bg_hover: "#3ce897",
      button_bg_hover: "#3ce897",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "KA",
      provider_name: "KA Điện Tử",
      icon: iconSlots.ka,
      logo_60_40: iconSlots.ka_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.ka_logo_lg,
      image: "",
      bg_color: "#bc0007",
      text_color: "#fff",
      active_color: "#000",
      text_active_color: "#fff",
      bg_hover: "linear-gradient(#f2622d, #bc0007)",
      button_bg_hover: "#fff",
      text_button_hover: "#c30c0c",
    },
    {
      type: "SL",
      provider_code: "PS",
      provider_name: "PS Điện Tử",
      icon: iconSlots.ps,
      logo_60_40: iconSlots.ps_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.ps_logo_lg,
      image: "",
      bg_color: "#333",
      text_color: "#fff",
      active_color: "#000",
      text_active_color: "#fff",
      bg_hover: "#6b6b6b",
      button_bg_hover: "linear-gradient(#6b6b6b, #818181)",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "R88",
      provider_name: "RICH88 Điện Tử",
      icon: iconSlots.rich88,
      logo_60_40: iconSlots.rich88_60_40,
      card_logo_lg: iconSlots.rich88_card_logo_lg,
      logo_lg: iconSlots.rich88_logo_lg,
      image: "",
      bg_color: "#601982",
      text_color: "#fff",
      active_color: "#ffd900",
      text_active_color: "#fff",
      bg_hover: "#601982",
      button_bg_hover: "#ffd900",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "PT",
      provider_name: "PT Điện Tử",
      icon: iconSlots.pt,
      logo_60_40: iconSlots.pt_60_40,
      card_logo_lg: "",
      logo_lg: "",
      image: "",
      bg_color: "#eee",
      text_color: "#312f6e",
      active_color: "#312f6e",
      text_active_color: "#fff",
      bg_hover: "#312f6e",
      button_bg_hover: "#312f6e",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "FTG",
      provider_name: "FTG Điện Tử",
      icon: iconSlots.ftg,
      logo_60_40: iconSlots.ftg_60_40,
      card_logo_lg: iconSlots.ftg_card_logo_lg,
      logo_lg: iconSlots.ftg_logo_lg,
      image: "",
      bg_color: "#64127e",
      text_color: "#fff",
      active_color: "#9828bc",
      text_active_color: "#fff",
      bg_hover: "#64127e",
      button_bg_hover: "#9828bc",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "NE",
      provider_name: "NE Điện Tử",
      icon: iconSlots.ne,
      logo_60_40: iconSlots.ne_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.ne_logo_lg,
      image: "",
      bg_color: "#68b022",
      text_color: "#fff",
      active_color: "#000",
      text_active_color: "#fff",
      bg_hover: "#68b022",
      button_bg_hover: "#000",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "HB",
      provider_name: "HB Điện Tử",
      icon: iconSlots.hb,
      logo_60_40: iconSlots.hb_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.hb_logo_lg,
      image: "",
      bg_color: "#fe2949",
      text_color: "#fff",
      active_color: "#000",
      text_active_color: "#ff0",
      bg_hover: "#fe2949",
      button_bg_hover: "linear-gradient(to right, #ef3c54, #f89729)",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "RSG",
      provider_name: "RSG Điện Tử",
      icon: iconSlots.rsg,
      logo_60_40: iconSlots.rsg_60_40,
      card_logo_lg: "",
      logo_lg: iconSlots.rsg_logo_lg,
      image: "",
      bg_color: "#ffa509",
      text_color: "#fff",
      active_color: "#ffe659",
      text_active_color: "#fff",
      bg_hover: "#ffa509",
      button_bg_hover: "#ffe659",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "GEM",
      provider_name: "GEM Điện Tử",
      icon: iconSlots.gem,
      logo_60_40: iconSlots.gem_60_40,
      card_logo_lg: "",
      logo_lg: "",
      image: "",
      bg_color: "#ffce77",
      text_color: "#fff",
      active_color: "#ffce77",
      text_active_color: "#fff",
      bg_hover: "#ffce77",
      button_bg_hover: "#ffce77",
      text_button_hover: "#fff",
    },
    {
      type: "SL",
      provider_code: "DGG",
      provider_name: "DG Điện tử",
      icon: "/slots/dragon_gaming_logo.png",
      logo_60_40: "/slots/dragon_gaming_logo.png",
      card_logo_lg: "",
      logo_lg: "",
      image: "",
      bg_color: "#ffce77",
      text_color: "#fff",
      active_color: "#ffce77",
      text_active_color: "#fff",
      isLocal: true,
      bg_hover: "#37d7f9",
      button_bg_hover: "#e1eefe",
      text_button_hover: "#1b2435",
    },
  ],
  // 4. sport
  SB: [
    {
      type: "SB",
      provider_code: "IGK",
      provider_name: "GX thể thao",
      icon: "sport-mobile/GX-icon.png",
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: "/sport-mobile/ibcgx.png",
      iconMobile: "/sport-mobile/GX-Mobile.png",
      imageMobile: "/v2/mobile/sports/gx.png",
      isLocal: true,
    },
    {
      type: "SB",
      provider_code: "SABA",
      provider_name: "SABA thể thao",
      icon: iconSport.saba,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageSport.saba_sport_live,
      iconMobile: iconSportMobile.saba,
      imageMobile: "/sport-mobile/1.png",
    },
    {
      type: "SB",
      provider_code: "CMD",
      provider_name: "CMD thể thao",
      icon: iconSport.cmd,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageSport.cmd_sport,
      iconMobile: iconSportMobile.cmd,
      imageMobile: "/v2/mobile/sports/cmd368.png",
    },
    {
      type: "SB",
      provider_code: "UG",
      provider_name: "UG thể thao",
      icon: iconSport.ug,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageSport.ug_sport,
      iconMobile: iconSportMobile.ug,
      imageMobile: "/sport-mobile/3.png",
    },
    {
      type: "SB",
      provider_code: "SBO",
      provider_name: "SBO thể thao",
      icon: iconSport.sbo,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageSport.spo_sport,
      iconMobile: iconSportMobile.sbo,
      imageMobile: "/v2/mobile/sports/sbo.png",
    },
  ],
  // 5. BOARD
  BG: [
    {
      type: "BG",
      provider_code: "V8",
      provider_name: "V8 Game Bài 3d",
      icon: iconBoard.v8,
      logo_60_40: iconBoard.v8_board_logo,
      card_logo_lg: "",
      logo_lg: iconBoard.v8_logo_lg,
      image: "",
      bg_color: "#000",
      text_color: "#fff",
      active_color: "#ffd050",
      text_active_color: "#fff",
      isLocal: true,
      bg_hover: "#ffd050",
      button_bg_hover: "#fff770",
      text_button_hover: "#000",
    },
    {
      type: "BG",
      provider_code: "R88",
      provider_name: "RICH88 Game Bài 3d",
      icon: iconBoard.rich88,
      logo_60_40: iconBoard.rich88_60_40,
      card_logo_lg: iconBoard.rich88_card_logo_lg,
      logo_lg: iconBoard.rich88_logo_lg,
      image: "",
      bg_color: "#601982",
      text_color: "#fff",
      active_color: "#ffd900",
      text_active_color: "#fff",
      bg_hover: "#601982",
      button_bg_hover: "#ffd900",
      text_button_hover: "#fff",
    },
    {
      type: "BG",
      provider_code: "KM",
      provider_name: "KM Game Bài 3d",
      icon: iconBoard.km,
      logo_60_40: iconBoard.km_60_40,
      card_logo_lg: iconBoard.km_card_lg,
      logo_lg: iconBoard.km_card_lg,
      image: "",
      bg_color: "#fda803",
      text_color: "#fff",
      active_color: "#ffe77a",
      text_active_color: "#fff",
      bg_hover: "linear-gradient(#edd171, #eeaf45)",
      button_bg_hover: "#fda803",
      text_button_hover: "#fff",
    },
    {
      type: "BG",
      provider_code: "TP",
      provider_name: "TP Game Bài 3d",
      icon: iconBoard.tp,
      logo_60_40: iconBoard.tp_60_40,
      card_logo_lg: iconBoard.tp_crad_logo_lg,
      logo_lg: iconBoard.tp_logo_lg,
      image: "",
      bg_color: "#0550bb",
      text_color: "#fff",
      active_color: "#003580",
      text_active_color: "#fff",
      bg_hover:
        "linear-gradient(to bottom, #11dac9 10%, #389dff 55%, #0550bb 100%)",
      button_bg_hover:
        "linear-gradient(to bottom, #11dac9 10%, #389dff 55%, #0550bb 100%)",
      text_button_hover: "#fff",
    },
    {
      type: "BG",
      provider_code: "JILI1",
      provider_name: "JILI Game Bài 3d",
      icon: iconBoard.jili,
      logo_60_40: iconBoard.jili_60_40,
      card_logo_lg: iconBoard.jili_card_logo_lg,
      logo_lg: iconBoard.jili_card_logo_lg,
      image: "",
      bg_color:
        "linear-gradient(to bottom, #fff468 0, #f3b720 33%, #eaa000 66%)",
      text_color: "#fff",
      active_color: "#642801",
      text_active_color: "#fff",
      bg_hover: "#f3b720",
      button_bg_hover:
        "linear-gradient(to bottom, #fff468 0, #f3b720 33%, #eaa000 66%)",
      text_button_hover: "#fff",
    },
    {
      type: "BG",
      provider_code: "MG",
      provider_name: "MG Game Bài 3d",
      icon: iconBoard.mg,
      logo_60_40: iconBoard.mg_60_40,
      card_logo_lg: iconBoard.mg_card_lg,
      logo_lg: iconBoard.mg_card_lg,
      image: "",
      bg_color: "#32b5e9",
      text_color: "#fff",
      active_color: "#21e519",
      text_active_color: "#000",
      bg_hover: "#32b5e9",
      button_bg_hover: "linear-gradient(45deg, #21e519, #32b5e9)",
      text_button_hover: "#fff",
    },
    {
      type: "BG",
      provider_code: "FTG",
      provider_name: "FTG Game Bài 3d",
      icon: iconBoard.ftg,
      logo_60_40: iconBoard.ftg_60_40,
      card_logo_lg: iconBoard.ftg_card_logo_lg,
      logo_lg: iconBoard.ftg_card_logo_lg,
      image: "",
      bg_color: "#64127e",
      text_color: "#fff",
      active_color: "#9828bc",
      text_active_color: "#fff",
      bg_hover: "#64127e",
      button_bg_hover: "#9828bc",
      text_button_hover: "#fff",
    },
  ],
  // 6. cook-fighting
  CF: [
    {
      type: "CF",
      provider_code: "WS16",
      provider_name: "WS168 đá gà",
      icon: iconCookFighting.ws168,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageCookFighting.WS16,
      iconMobile: iconCookFightingMobile.ws168,
      imageMobile: "/cook-fighting-mobile/1.png",
    },
    {
      type: "CF",
      provider_code: "WGB",
      provider_name: "WGB đá gà",
      icon: iconCookFighting.wgb,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageCookFighting.cock_fighting,
      iconMobile: iconCookFightingMobile.wgb,
      imageMobile: "/cook-fighting-mobile/wgb-cf.png",
    },
  ],
  // 7. LOTTERY
  LT: [
    {
      type: "LT",
      provider_code: "OC",
      provider_name: "On Casino Xổ Số",
      icon: "/lottery/cg-icon.png",
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: "/lottery/LotteryBanner.png",
      iconMobile: "/lottery/cglogo.png",
      imageMobile: "/lottery/image-mobile-cg.png",
      isLocal: true,
    },
    // {
    //   type: "LT",
    //   provider_code: "TG",
    //   provider_name: "Top Gaming Xổ Số",
    //   icon: iconLottery.gw,
    //   logo_60_40: "",
    //   card_logo_lg: "",
    //   logo_lg: "",
    //   image: imageLottery.gw_lottery,
    //   iconMobile: iconLotteryMobile.gw,
    //   imageMobile: "/lottery/3.png",
    //   isLocal: true,
    // },
    {
      type: "LT",
      provider_code: "TP",
      provider_name: "TP Xổ Số",
      icon: iconLottery.tp,
      logo_60_40: iconLottery.tp_60_40,
      card_logo_lg: iconLottery.tp_card_logo_lg,
      logo_lg: iconLottery.tp_logo_lg,
      image: imageLottery.tp_lottery,
      iconMobile: iconLotteryMobile.tp,
      imageMobile: "/lottery/1.png",
    },
    {
      type: "LT",
      provider_code: "VR",
      provider_name: "VR Xổ Số",
      icon: iconLottery.vr,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLottery.vr_lottery,
      iconMobile: iconLotteryMobile.vr,
      imageMobile: "/lottery/2.png",
    },
    {
      type: "LT",
      provider_code: "GW",
      provider_name: "GW Xổ Số",
      icon: iconLottery.gw,
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLottery.gw_lottery,
      iconMobile: iconLotteryMobile.gw,
      imageMobile: "/lottery/3.png",
    },
    {
      type: "LT",
      provider_code: "",
      provider_name: "Đang sắp diễn ra",
      icon: "",
      logo_60_40: "",
      card_logo_lg: "",
      logo_lg: "",
      image: imageLottery.item_maintenance,
    },
  ],
};

export const fishingConfig: GamePageConfigType = {
  logo: iconFishing.fish_logo,
  background: imageFishing.backgroundFishing,
  bg_color: "#048db8",
  text_color: "#fff",
  active_color: "#31b5e9",
  text_active_color: "#ff0",
};

export const providerHotGame: ProviderItemType[] = [
  {
    type: "LC",
    provider_code: "SX",
    provider_name: "SE Trực tuyến",
    icon: "",
    logo_60_40: "",
    card_logo_lg: "",
    logo_lg: "",
    image: "",
    imageMobile: "/v2/mobile/hot-game/se.png",
  },
  {
    type: "LC",
    provider_code: "DG",
    provider_name: "DG Trực Tuyến",
    icon: "",
    logo_60_40: "",
    card_logo_lg: "",
    logo_lg: "",
    image: "",
    imageMobile: "/v2/mobile/hot-game/dg.png",
  },
  // {
  //   type: "SB",
  //   provider_code: "SABA",
  //   provider_name: "SABA Thể Thao",
  //   icon: "",
  //   logo_60_40: "",
  //   card_logo_lg: "",
  //   logo_lg: "",
  //   image: "",
  //   imageMobile: "/v2/mobile/hot-game/dg.png",
  // },
  // {
  //   type: "LC",
  //   provider_code: "WM",
  //   provider_name: "WM Tài Xỉu",
  //   icon: iconLive.wm,
  //   logo_60_40: "",
  //   card_logo_lg: "",
  //   logo_lg: "",
  //   image: "",
  //   imageMobile: "/v2/mobile/hot-game/WM.png",
  // },
];
